export default __webpack_public_path__ + "static/media/05_otherDiagnostic.04e6aa06.png";